import './App.css';
import AppRouter from './Components/Router/AppRouter/AppRouter';
import React from 'react';

function App() {

  return (
    <div className="App">
     <AppRouter />
    </div>
  );
}

export default App;
